import React from "react";
import CRMContactPopoverMenuMore from "./popover/popover-more";
import FieldDropdownDynamic from "../../../generic/dropdown-dynamic/dropdown-dynamic";
import FieldConfig from "../../../proto/field-config";

export default class FieldCrmContact extends FieldDropdownDynamic {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Contact";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','No contact');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-contact';

        this.isSearchable = true;

        this.components = _.assign({}, this.components, {
            PopoverMenuMore : CRMContactPopoverMenuMore,
            ValueIcon       : <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        })
    }

    getOptions() {

        if (!this._options) {

            if (gd.session._crmContacts) {
                this._options = gd.session._crmContacts.exportToOptions()
            } else {
                console.error("Try access session.crmContacts but not initialized #jd932")
                return []
            }

        }

        return this._options
    }
}
